import React, { useState } from 'react'
import { useNavigate, Link, useLocation } from 'react-router-dom'
import GoogleSignIn from '../components/GoogleSignIn'
import { useAuth } from '../contexts/AuthContext'
import toast from 'react-hot-toast'
import {domusApi} from '../services/domusApi'

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  })
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const [apiStatus,setApiStatus]=useState('checking')
  React.useEffect(()=>{
    let active=true
    const controller=new AbortController()
    const timer=setTimeout(()=>controller.abort(),6000)
    fetch('/api/healthz',{cache:'no-store',signal:controller.signal}).then(async res=>{
      if(!res.ok)throw Error('API indisponível ('+res.status+')')
      const data=await res.json();if(data.status!=='ok')throw Error('API não operacional')
      if(active)setApiStatus('ok')
    }).catch(()=>{if(active)setApiStatus('down')}).finally(()=>clearTimeout(timer))
    return()=>{active=false;controller.abort();clearTimeout(timer)}
  },[])
  const { signIn } = useAuth()

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      await signIn(formData.email, formData.password)
      toast.success('Login realizado com sucesso!')
      
      const families = await domusApi.families()
      navigate(families.data?.length ? (location.state?.from || '/dashboard') : '/family-setup')
    } catch (error) {
      console.error("Erro no login:", error)
      toast.error(error.message || 'E-mail ou senha inválidos. Se tinha uma conta Firebase, terá de migrar os seus dados.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 to-indigo-800 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-2xl p-8 border border-blue-100">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <div className="h-16 w-16 bg-blue-600 rounded-full flex items-center justify-center">
              <span className="text-3xl text-white">🏠</span>
            </div>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">DOMUS SELF FAMILY</h1>
          <p className="text-gray-600 font-medium">Acesso individual</p>
          <p className="text-sm text-gray-500">Entre com a sua conta pessoal para aceder à sua família. Não existe senha coletiva da família.</p>
        </div>

        {apiStatus==='down'&&<div role="alert" className="rounded-lg border border-red-300 bg-red-50 p-3 mb-5 text-sm text-red-800"><strong>Servidor familiar indisponível.</strong> O frontend está acessível, mas a API de registo e login não responde corretamente em /api/healthz. O deploy requer os serviços web, api e postgres no Docker Compose do Coolify.</div>}
        {apiStatus==='checking'&&<p role="status" className="mb-4 text-sm text-amber-800">A verificar ligação ao servidor familiar...</p>}
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
              E-mail
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="seu@email.com"
              required
            />
          </div>

          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
              Senha
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Sua senha"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading||apiStatus!=='ok'}
            className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors font-medium shadow-md"
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <div className="mt-6">
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300" />
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 bg-white text-gray-500">Ou</span>
            </div>
          </div>

          <GoogleSignIn />
        </div>

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600">
            Primeiro acesso ao DOMUS?{' '}
            <Link to="/register" className="text-blue-600 hover:text-blue-500 font-medium">Criar conta Master ou familiar</Link>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Login
